"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OptionContactCard = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _react = _interopRequireDefault(require("react"));
var _colors = require("../../../../constants/colors");
var _i18n = require("../../../../i18n/i18n");
var _contactcard = require("../../../contactcard");
var _types = require("../../types");
const OptionContactCard = _ref => {
  let {
    option,
    onMouseEnter,
    onMouseLeave,
    onViewMembers,
    onExpandMembers,
    showExpandMembers
  } = _ref;
  return (0, _types.isGroupContact)(option) ? /*#__PURE__*/_react.default.createElement(GroupOptionContactCard, {
    option: option,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onViewMembers: onViewMembers,
    onExpandMembers: onExpandMembers,
    showExpandMembers: showExpandMembers
  }) : /*#__PURE__*/_react.default.createElement(IndividualOptionContactCard, {
    option: option,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  });
};
exports.OptionContactCard = OptionContactCard;
const IndividualOptionContactCard = _ref2 => {
  let {
    onMouseEnter,
    onMouseLeave,
    option
  } = _ref2;
  const {
    i18n
  } = (0, _i18n.useI18n)();
  const {
    id,
    emailAddress,
    initials,
    company,
    department,
    mobilePhone,
    name,
    profileImageUrl,
    title,
    workPhone
  } = option;
  return /*#__PURE__*/_react.default.createElement(_contactcard.ContactCard, {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    "aria-label": i18n._( /* i18n */{
      comment: "This aria label is read to the user when the screen reader focuses on the contact card the appears upon hover of a contact picker option. The comma is important so screen readers can provide a short pause between the 'Contact card' label and the contact's name",
      id: "Contact card, {name}",
      values: {
        name: name ?? emailAddress
      }
    }),
    avatarProps: {
      initials: initials,
      src: profileImageUrl,
      email: emailAddress || name || id
    }
  }, name && /*#__PURE__*/_react.default.createElement(_contactcard.ContactCardName, {
    "aria-label": i18n._( /* i18n */{
      comment: "This aria label is read to the user when the screen reader focuses on the name in the contact card. The comma is important so screen readers can provide a short pause between the 'Name' label and the contact's name",
      id: "Name, {name}",
      values: {
        name
      }
    })
  }, name), !name && emailAddress && /*#__PURE__*/_react.default.createElement(_contactcard.ContactCardName, {
    "aria-label": i18n._( /* i18n */{
      comment: "This aria label is read to the user when the screen reader focuses on the email in the contact card. The comma is important so screen readers can provide a short pause between the 'Email' label and the contact's email",
      id: "Email, {emailAddress}",
      values: {
        emailAddress
      }
    })
  }, emailAddress), title && /*#__PURE__*/_react.default.createElement(_contactcard.ContactCardDetailItem, {
    "aria-label": i18n._( /* i18n */{
      comment: "This aria label is read to the user when the screen reader focuses on the contact's job title in the contact card. The comma is important so screen readers can provide a short pause between the 'Title' label and the contact's title",
      id: "Title, {title}",
      values: {
        title
      }
    })
  }, title), department && /*#__PURE__*/_react.default.createElement(_contactcard.ContactCardDetailItem, {
    "aria-label": i18n._( /* i18n */{
      comment: "This aria label is read to the user when the screen reader focuses on the contact's company department in the contact card. The comma is important so screen readers can provide a short pause between the 'Department' label and the contact's department",
      id: "Department, {department}",
      values: {
        department
      }
    })
  }, department), company && /*#__PURE__*/_react.default.createElement(_contactcard.ContactCardDetailItem, {
    "aria-label": i18n._( /* i18n */{
      comment: "This aria label is read to the user when the screen reader focuses on the contact's company in the contact card. The comma is important so screen readers can provide a short pause between the 'Company' label and the contact's company",
      id: "Company, {company}",
      values: {
        company
      }
    })
  }, company), name && emailAddress && /*#__PURE__*/_react.default.createElement(_contactcard.ContactCardInfoItem, {
    "aria-label": i18n._( /* i18n */{
      comment: "This aria label is read to the user when the screen reader focuses on the contact's email in the contact card. The comma is important so screen readers can provide a short pause between the 'Email' label and the contact's email",
      id: "Email, {emailAddress}",
      values: {
        emailAddress
      }
    })
  }, emailAddress), workPhone && /*#__PURE__*/_react.default.createElement(_contactcard.ContactCardInfoItem, {
    "aria-label": i18n._( /* i18n */{
      comment: "This aria label is read to the user when the screen reader focuses on the contact's work phone number in the contact card. The comma is important so screen readers can provide a short pause between the 'Work phone' label and the contact's work phone",
      id: "Work phone, {workPhone}",
      values: {
        workPhone
      }
    })
  }, i18n._( /* i18n */{
    comment: "This is the selected contact's work phone number",
    id: "Work: {workPhone}",
    values: {
      workPhone
    }
  })), mobilePhone && /*#__PURE__*/_react.default.createElement(_contactcard.ContactCardInfoItem, {
    "aria-label": i18n._( /* i18n */{
      comment: "This aria label is read to the user when the screen reader focuses on the contact's mobile phone number in the contact card. The comma is important so screen readers can provide a short pause between the 'Mobile phone' label and the contact's mobile phone",
      id: "Mobile phone, {mobilePhone}",
      values: {
        mobilePhone
      }
    })
  }, i18n._( /* i18n */{
    comment: "This is the selected contact's mobile phone number",
    id: "Mobile: {mobilePhone}",
    values: {
      mobilePhone
    }
  })));
};
const StyledGroupContactCard = (0, _styled.default)(_contactcard.ContactCard)`
    width: fit-content;
`;
const GroupOptionContactCard = _ref3 => {
  let {
    onExpandMembers,
    onMouseEnter,
    onMouseLeave,
    onViewMembers,
    option,
    showExpandMembers
  } = _ref3;
  const {
    i18n
  } = (0, _i18n.useI18n)();
  const {
    name,
    userCount
  } = option;
  return /*#__PURE__*/_react.default.createElement(StyledGroupContactCard, {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    "aria-label": i18n._( /* i18n */{
      comment: "This aria label is read to the user when the screen reader focuses on the contact card the appears upon hover of a contact picker option. The comma is important so screen readers can provide a short pause between the 'Contact card' label and the group's name",
      id: "Contact card, {name}",
      values: {
        name
      }
    }),
    avatarProps: {
      color: {
        backgroundColor: _colors.visBlueLight20,
        textColor: _colors.neutralDark40
      },
      content: /*#__PURE__*/_react.default.createElement(_lodestarIcons.ShareIcon, {
        size: "medium"
      })
    },
    style: {
      width: "fit-content"
    }
  }, /*#__PURE__*/_react.default.createElement(_contactcard.ContactCardName, {
    "aria-label": i18n._( /* i18n */{
      comment: "This aria label is read to the user when the screen reader focuses on the name in the contact card. The comma is important so screen readers can provide a short pause between the 'Name' label and the contact's name",
      id: "Name, {name}",
      values: {
        name
      }
    })
  }, name), userCount && /*#__PURE__*/_react.default.createElement(_contactcard.ContactCardDetailItem, null, i18n._( /* i18n */{
    comment: "This displays a count of how many members are in the selected group",
    id: "Group - {members, plural, one {# member} other {# members}}",
    values: {
      members: userCount
    }
  })), onViewMembers && /*#__PURE__*/_react.default.createElement(_contactcard.ContactCardAction, {
    onMouseDown: e => {
      if (onViewMembers != undefined) {
        e.preventDefault();
        onViewMembers(e, option.members || [], option);
      }
    },
    "aria-label": i18n._( /*i18n*/"Click here to view the group members")
  }, i18n._( /*i18n*/"View members")), showExpandMembers && onExpandMembers && /*#__PURE__*/_react.default.createElement(_contactcard.ContactCardAction, {
    onMouseDown: () => {
      if (onExpandMembers != undefined) {
        onExpandMembers(option);
      }
    },
    "aria-label": i18n._( /*i18n*/"Click here to expand the group members")
  }, i18n._( /*i18n*/"Expand members")));
};
//# sourceMappingURL=OptionContactCard.js.map